import { render, staticRenderFns } from "./PropTable.vue?vue&type=template&id=02313860&scoped=true&"
import script from "./PropTable.vue?vue&type=script&lang=js&"
export * from "./PropTable.vue?vue&type=script&lang=js&"
import style0 from "./PropTable.vue?vue&type=style&index=0&id=02313860&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02313860",
  null
  
)

export default component.exports